/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

// Host-chrome unread state (AC-11.1/FR-16, OQ-3/ADR-0003): the top-bar Chat entry button
// (`ChatTopBarEntry.vue`) can no longer read `$store.state.chat.conversations` (the Vuex chat
// module is retired — the island owns that state now, FR-04). A tiny Vue-reactive singleton, fed
// exclusively by `ChatHost.onUnreadChange` (see `buildImsChatHost.js`), is the whole "host chrome
// reads a count the island publishes" channel this needs — no Vuex module required for one number.
import Vue from 'vue';

const state = Vue.observable({ unreadCount: 0 });

export function setChatBadgeUnreadCount(count) {
  state.unreadCount = count;
}

export function useChatBadgeState() {
  return state;
}
